import { apiRequest } from './apiClient';

export const fetchCultureContent = async () => (await apiRequest('/culture-content')).data;
export const deleteCultureContent = async id => apiRequest(`/culture-content/${id}`, { method: 'DELETE' });
export const bulkUpdateCultureStatus = (ids, status) => apiRequest('/culture-content/bulk-status', { method: 'PATCH', body: JSON.stringify({ ids, status }) });
export const bulkDeleteCultureContent = ids => apiRequest('/culture-content/bulk-delete', { method: 'DELETE', body: JSON.stringify({ ids }) });

function toFormData(form) {
  const body = new FormData();
  body.append('department', form.department);
  // body.append('title', form.title);
  // body.append('description', form.description);
  body.append('status', form.status);
  const mediaMeta = [];
  let fileIndex = 0;
  let posterFileIndex = 0;
  form.media.forEach(item => {
    if (item.existingId) {
      const meta = {
        existingId: item.existingId,
        alt: item.type === 'image' ? (item.alt || '').trim() : '',
        posterAlt: item.type === 'video' ? (item.posterAlt || '').trim() : ''
      };
      if (item.poster) { meta.posterFileIndex = posterFileIndex++; body.append('posters', item.poster); }
      mediaMeta.push(meta);
    }
    else {
      const meta = {
        fileIndex: fileIndex++,
        alt: item.type === 'image' ? (item.alt || '').trim() : '',
        posterAlt: item.type === 'video' ? (item.posterAlt || '').trim() : ''
      };
      body.append('media', item.file);
      if (item.file.type.startsWith('video/')) { meta.posterFileIndex = posterFileIndex++; body.append('posters', item.poster); }
      mediaMeta.push(meta);
    }
  });
  body.append('mediaMeta', JSON.stringify(mediaMeta));
  return body;
}

export const createCultureContent = form => apiRequest('/culture-content', { method: 'POST', body: toFormData(form) }).then(result => result.data);
export const updateCultureContent = (id, form) => apiRequest(`/culture-content/${id}`, { method: 'PATCH', body: toFormData(form) }).then(result => result.data);
